const styles = {
  icon: {
    marginRight: 16,
    fontSize: 24,
  },
  settingView: {
    background: "white",
    marginTop: 32,
    // marginRight: 128,
    // marginLeft: 128,
    padding: 32,
  },
};

export default styles;
